import crypto from "crypto";

/* prettier-ignore */
import { CognitoIdentityProviderClient, AdminCreateUserCommand,ListUsersCommand } from "@aws-sdk/client-cognito-identity-provider";
import { REGION } from "~/_server/constants";

export const COGNITO_IDP: string = `https://cognito-idp.${REGION}.amazonaws.com/`;
export const COGNITO_USERPOOL: string = "eu-west-2_gUi1FoXY3";
export const COGNITO_CLIENTID: string = "2cskdf8d8gff49f8rn1baa6aku";
//export const COGNITO_USERPOOL: string = "eu-west-2_Z9UGIz3X7";
//export const COGNITO_CLIENTID: string = "6q8o02g8hkc67st0pkdojtvbpu";

export const COGNITO_ISSUER: string = `${COGNITO_IDP}${COGNITO_USERPOOL}`;

const generatePassword = ( length = 12 ) => {
	"use server";
	const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
	const lower = "abcdefghijklmnopqrstuvwxyz";
	const digits = "0123456789";
	const symbols = "!@#$%^&*()-_=+[]{}";
	const all = upper + lower + digits + symbols;

	// Ensure at least one of each
	let password = [
		upper[Math.floor(Math.random() * upper.length)],
		lower[Math.floor(Math.random() * lower.length)],
		digits[Math.floor(Math.random() * digits.length)],
		symbols[Math.floor(Math.random() * symbols.length)],
	];

	// Fill the rest
	for (let i = password.length; i < length; i++) {
		password.push(all[crypto.randomInt(0, all.length)]);
	}

	// Shuffle
	return password.sort(() => 0.5 - Math.random()).join("");
};

export const findCognitoUserByEmail = async ( email: string ) => {
	"use server";

	try {
		const client = new CognitoIdentityProviderClient( { region: REGION } );
		const command = new ListUsersCommand( {
			UserPoolId: COGNITO_USERPOOL,
			Filter: `email = "${email}"`,
			Limit: 1, // optional
		} );

		const r = await client.send( command );

		return r.Users?.[0] ?? null;
	} catch ( err ) {
		console.error( "Error finding Cognito user:", err );
		return null;
	}
};

export const createCognitoUser = async (
	email: string,
	familyName: string,
	givenName: string,
	id: number
) => {
	"use server";

	try {
		const client = new CognitoIdentityProviderClient( { region: REGION } );
		//const tempPassword = generatePassword(); // Because Cognito requires one. This will never be used.

		const attrbs = [
			{ Name: "email", Value: email },
			{ Name: "email_verified", Value: "true" },
			{ Name: "profile", Value: id.toString() },
			{ Name: "family_name", Value: familyName },
			{ Name: "given_name", Value: givenName },
			{ Name: "preferred_username", Value: email },
			{ Name: "zoneinfo", Value: "Europe/London" },
		];

		console.log( "Creating Cognito user with attributes:", attrbs );
		// Cognito usernames must match [\p{L}\p{M}\p{S}\p{N}\p{P}]+ — whitespace is not allowed
		const usernamePart = ( s: string ) => s.replace( /\s+/g, "" );

		try {
			const command = new AdminCreateUserCommand( {
				UserPoolId: COGNITO_USERPOOL,
				Username: `${usernamePart( givenName )}.${usernamePart( familyName )}.#${id}`.toLowerCase(), // Ensure uniqueness

				UserAttributes: attrbs,
				//TemporaryPassword: tempPassword,
				MessageAction: "SUPPRESS", // Don't send any invitations
			} );

			const r = await client.send( command );
			
		
			return r.User ?? null;
		} catch ( err ) {
			console.error( "Error sending AdminCreateUserCommand:", err );
			return null;
		}
	} catch ( err ) {
		console.error( "Error creating Cognito user:", err );
		return null;
	}
};

// The users page has an access icon that creates the Cognito account by hand.
// Verification should not depend on someone remembering to click it: the
// "you are invited to join" email is the moment they need an account to exist.
//
// Safe to call repeatedly - it looks for an existing account first, and a user
// who already carries a sub is left alone.
export const ensureCognitoUser = async ( user: any ): Promise<string | null> => {
	"use server";

	if ( !user?.email || !user?.userId ) return null;
	if ( user.sub ) return user.sub;

	try {
		let cognitoUser = await findCognitoUserByEmail( user.email );

		if ( !cognitoUser?.Attributes ) {
			cognitoUser = await createCognitoUser( user.email, user.lastName, user.firstName, user.userId );
		}

		const sub = cognitoUser?.Attributes?.find( ( a: any ) => a.Name == "sub" )?.Value;

		if ( !sub ) {
			console.error( "No Cognito sub returned for", user.email );
			return null;
		}

		const { updateDB } = await import( "./dynamoDB" );

		await updateDB( `USER#${user.userId}`, `USER#${String( user.userId ).padStart( 7, "0" )}`, { sub } );

		return sub;
	} catch ( err ) {
		// Never let this stop the verification - the icon is still there as a fallback.
		console.error( "Could not create the Cognito account for", user.email, err );

		return null;
	}
};
